/**
 * Flagship video autoplay: muted videos inside .flagship-video-hosted start
 * playing when they come near the viewport and pause when scrolled away.
 */
(function () {
  if (window.flagshipVideoAutoplayInitialized) return;
  window.flagshipVideoAutoplayInitialized = true;

  var NEAR_VIEWPORT = '200px 0px';

  function init() {
    var videos = document.querySelectorAll('.flagship-video-hosted video');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) {
        video.play().catch(function () {});
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.play().catch(function () {});
          } else {
            entry.target.pause();
          }
        });
      },
      { rootMargin: NEAR_VIEWPORT }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
